import React, { Fragment, useState } from 'react';

import Grid from '@mui/material/Grid2';
import {
  TextField,
  Box,
  Typography,
  Button,
  Stack,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import Card from '@mui/material/Card';
import { TextEditedContent } from 'components';
import api from 'utils/api';
import { DOLPHIN_API } from 'shared/constants/apis';
import PropTypes from 'prop-types';
import { AdminModal } from '../components/styles';
import { useSnackbar } from 'notistack';

const propTypes = {
  close: PropTypes.func.isRequired,
  fetchOrgs: PropTypes.func.isRequired,
};

const IWGDashboardOrganizationsNew = ({ close, fetchOrgs }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [formState, setFormState] = useState({
    name: '',
    accelerateEnabled: false,
    organizationCode: '',
    contact: {
      zipCode: '110-1010',
      addressLine1: '東京都新宿区新宿1-2-3',
      addressLine2: '新宿第1ビル2階',
      tel: '070-0070-0700',
      fax: '070-7000-0700',
    },
    paymentMethod: {
      bank: '○○銀行',
      branch: '△△支店',
      accountType: '当座',
      accountNo: '0123456',
      accountName: 'サンプル(カ',
    },
  });
  const [incompleteFields, setIncompleteFields] = useState([]);
  const [incompleteWarningModalOpen, setIncompleteWarningModalOpen] =
    useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);

  const keyToCheck = ['name', 'organizationCode', 'accelerateEnabled'];

  const keyToLabel = {
    name: 'Organization Name',
    organizationCode: 'Organization Code',
    accelerateEnabled: 'Enable S3 Accelerate',
    cloudFrontEnabled: 'Enable CloudFront',
  };

  const handleChange = (key) => async (event) => {
    setFormState((prevState) => ({
      ...prevState,
      [key]: event.target.value,
    }));
  };

  const sendToServer = async () => {
    const data = { ...formState };
    await api.post(DOLPHIN_API.ADMIN_ORGS, {
      data: {
        createdData: [data],
      },
    });
    await fetchOrgs();
    enqueueSnackbar('Organization created successfully', {
      variant: 'success',
    });
    close();
  };

  const checkIfFormCompleted = () => {
    const _incompleteFields = [];

    keyToCheck.forEach((key) => {
      const value = formState[key];
      if (value.length === 0) {
        _incompleteFields.push(keyToLabel[key]);
      }
    });

    if (_incompleteFields.length > 0) {
      setIncompleteFields(_incompleteFields);
      return false;
    } else {
      return true;
    }
  };

  const handleSubmitClick = async (event) => {
    event.preventDefault();
    if (!checkIfFormCompleted()) {
      setIncompleteWarningModalOpen(true);
    } else {
      setConfirmModalOpen(true);
    }
  };

  return (
    <Fragment>
      <Box py={3} px={3} mt={3} mx={3}>
        <Stack spacing={3}>
          <TextField
            id="name"
            name="name"
            fullWidth
            variant="outlined"
            label="Organization Name"
            onChange={handleChange('name')}
            value={formState.name}
          />

          <TextField
            id="organizationCode"
            name="organizationCode"
            fullWidth
            variant="outlined"
            label="Organization Code"
            onChange={handleChange('organizationCode')}
            value={formState.organizationCode}
          />

          <FormControlLabel
            control={
              <Checkbox
                id="accelerateEnabled"
                name="accelerateEnabled"
                onChange={handleChange('accelerateEnabled')}
                value={formState.accelerateEnabled}
              />
            }
            label="Enable S3 Accelerate"
          />

          <Grid
            spacing={3}
            container
            alignItems="center"
            justifyContent="space-between">
            <Grid>
              <Button
                variant="contained"
                color="primary"
                style={{
                  color: 'white',
                }}
                onClick={handleSubmitClick}>
                Submit
              </Button>
            </Grid>
            <Grid>
              <Button variant="contained" color="secondary" onClick={close}>
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Stack>

        {/* Modal for warning */}
        <AdminModal
          open={incompleteWarningModalOpen}
          onClose={() => setIncompleteWarningModalOpen(false)}>
          <Card sx={{ margin: 4, marginTop: 3, width: 800 }}>
            <Box py={3} px={3} mt={3} mx={3}>
              <Typography mb={1}>Warning</Typography>
              <Typography>The following information is incomplete!</Typography>
              <br />
              {incompleteFields &&
                incompleteFields.map((field, index) => (
                  <p style={{ color: 'red' }} key={index}>
                    {field}
                  </p>
                ))}
              <br />
            </Box>
          </Card>
        </AdminModal>
        {/* Modal for confirm */}
        <AdminModal
          open={confirmModalOpen}
          onClose={() => setConfirmModalOpen(false)}>
          <Card sx={{ margin: 4, marginTop: 3, width: 800 }}>
            <Box py={3} px={3} mt={3} mx={3}>
              <Typography mb={1}>Confirm</Typography>
              <Typography>
                You are going to create a new organization as below:
              </Typography>
              <TextEditedContent
                content={JSON.stringify(formState, undefined, 4)}
              />
              <Grid
                spacing={3}
                container
                alignItems="center"
                justifyContent="space-between">
                <Grid>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{
                      color: 'white',
                    }}
                    onClick={sendToServer}>
                    Confirm
                  </Button>
                </Grid>
                <Grid>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      setIncompleteWarningModalOpen(false);
                      setConfirmModalOpen(false);
                    }}>
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Card>
        </AdminModal>
      </Box>
    </Fragment>
  );
};

IWGDashboardOrganizationsNew.propTypes = propTypes;

export default IWGDashboardOrganizationsNew;
